// extracted by mini-css-extract-plugin
module.exports = {"shopini-logistics":"styles_shopini-logistics__3h-gC","are-you-retailer":"styles_are-you-retailer__JwYV0","upscale-business":"styles_upscale-business__1qthd"};